export const CONSENT_EVENTS = {
  granted: 'consent_granted',
  declined: 'consent_declined',
} as const;

export type ConsentEventNameType = (typeof CONSENT_EVENTS)[keyof typeof CONSENT_EVENTS];
